import type { SourceFile } from "../sources-types";
import { isDataBankViewType, type DataBankViewType } from "./dataBankViewTypes";

type DbFields = Partial<
    Pick<
        SourceFile,
        | "data_bank_fst_key"
        | "data_bank_fsd_id"
        | "data_bank_election"
        | "data_bank_view_type"
        | "data_bank_map_key"
    >
>;

/** Maps TARS `more` for `data_bank` sources onto `SourceFile` optional fields. */
export function dataBankDisplayFieldsFromMore(more?: Record<string, unknown>): DbFields {
    if (!more) return {};
    const out: DbFields = {};
    if (typeof more.fst_key === "string" && more.fst_key.trim() !== "") {
        out.data_bank_fst_key = more.fst_key.trim();
    }
    const idNum = Number(more.fsd_id);
    if (!Number.isNaN(idNum)) out.data_bank_fsd_id = idNum;
    if (typeof more.election_label === "string" && more.election_label.trim() !== "") {
        out.data_bank_election = more.election_label.trim();
    }
    const viewRaw = typeof more.view_type === "string" ? more.view_type.trim() : "";
    if (isDataBankViewType(viewRaw)) out.data_bank_view_type = viewRaw as DataBankViewType;
    if (typeof more.map_key === "string" && more.map_key.trim() !== "") {
        out.data_bank_map_key = more.map_key.trim();
    }
    return out;
}
